namespace Areas.Analysis {
    "use strict";

    const tabItems = Areas.createTabsWithSameController("Analysis",
        ["Created", "InProcess", "Completed", "Template", "Deleted"], "Workflow");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    const viewUrl = "/Workflows/View/Index/";

    export function gotoView() {
        gotoSelected(getDataGridName(), viewUrl, (row) => { return row.workflowId; });
    }

    export function viewLink(cellElement, cellInfo) {
        buildCellContent(cellElement, () => { return cellInfo.data.workflowId; },
            `<a href= '${viewUrl}{placeholder}'>View</a>`);
    }

    export function cellPreparedPivotGrid(e: any) {
        if (isWorkflowNameColumn(e) || isWorkflowLinkColumn(e) || isWorkflowDateColumn(e)) {
            const workflowLink = e.cell.text;
            e.cellElement.html(workflowLink);
        } else if (isWorkflowDetailIdColumn(e)) {
            e.cellElement.html("");
        }
        else if (isDataColumn(e)) {
            setContent(e);
        }
    }

    export function calculateSummaryValue(args) {
        if (args.field("row")) {
            if (args.field("row").dataField === "workflowName"
                || args.field("row").dataField === "projectName"
                || args.field("row").dataField === "displayDueDate"
                ) {
                return "";  //Show blank on the workflowName and projectName summary row
            }
            else {
                return args.value("html") || "";    //Return an empty string if value is null to prevent cell from being hidden
            }
        }
    }

    function getDataGridName() : string {
        const url = window.location.href;
        if (url.indexOf("Approve") > 0)
            return "AnalysisApproveWorkflowGrid";
        else if (url.indexOf("Created") > 0)
            return "AnalysisCreatedWorkflowGrid";
        else if (url.indexOf("InProcess") > 0)
            return "AnalysisInProcessWorkflowGrid";
        else if (url.indexOf("Completed") > 0)
            return "AnalysisCompletedWorkflowGrid";
        else if (url.indexOf("Template") > 0)
            return "AnalysisTemplatesWorkflowGrid";
        else if (url.indexOf("Deleted") > 0)
            return "AnalysisDeletedWorkflowGrid";
    };

    function isWorkflowNameColumn(e: any): boolean {
        return e.area === "row" && e.cell.path && e.cell.path.length === 2;
    }

    function isWorkflowDateColumn(e: any): boolean {
        return e.area === "row" && e.cell.path && e.cell.path.length === 3;
    }

    function isWorkflowLinkColumn(e: any): boolean {
        return e.area === "row" && e.cell.path && e.cell.path.length === 4;
    }

    function isWorkflowDetailIdColumn(e: any): boolean {
        return e.area === "row" && e.cell.path && e.cell.path.length === 5;
    }

    function isDataColumn(e: any): boolean {
        return e.area === "data" && e.cell.text !== "undefined" && e.cell.text !== "";
    }

    function setContent(e: any) {
        const data = e.cell.text.split("|");
        const [user, actionTaken, dateActionTaken] = data;
        let content = user + "<br>" + actionTaken;

        if (dateActionTaken) {
            const date = new Date(dateActionTaken);

            content = content + "<br>" + formatDateTime(date);
        }

        if (!dateActionTaken) {
            e.cellElement.css("background-color", "#fafad2" );
        }

        e.cellElement.html(content);
    }

}